import { useQuery } from "@tanstack/react-query";

import { AdminMainCropDetection, getFarmMainCropDetections } from "services";

import { GET_FARM_MAIN_CROP_DETECTIONS } from "consts";

export const useGetFarmMainCropDetections = ({ farmId }: { farmId: string }) =>
  useQuery<AdminMainCropDetection[]>({
    queryKey: [GET_FARM_MAIN_CROP_DETECTIONS, farmId],
    queryFn: () => getFarmMainCropDetections({ farmId }),
    enabled: !!farmId,
    staleTime: 1000 * 60 * 5,
  });
